import React, { FunctionComponent, useState } from 'react'
import axios from 'axios'
import Toaster from '../Toaster'
import styles from './AdminToolsTab.module.css'

interface Props {
  teamID: string
  customerID: string
}

export const AdminToolsTab: FunctionComponent<Props> = ({ teamID, customerID }) => {
  const [selectedBrief, setSelectedBrief] = useState<string>('')
  const [loading, setLoading] = useState(false)

  const handleRebuild = () => {
    if (!selectedBrief) return

    setLoading(true)
    axios
      .delete(`/api/teams/${teamID}/customers/${customerID}/briefs/${selectedBrief}`)
      .then(() => {
        Toaster.notifySuccess('Brief cache deleted successfully. It will be rebuilt on next access.')
        setSelectedBrief('')
      })
      .catch(err => {
        Toaster.notifyFailure(err.message || 'An error occurred while deleting the brief cache')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <div className={`surface ${styles.container}`}>
      <h2 className={styles.heading}>Admin Tools</h2>

      <div className={styles.formGroup}>
        <p className={styles.description}>
          Select a brief cache to delete. This forces the brief to be regenerated from fresh data upon next access.
        </p>

        <div className='field'>
          <label htmlFor='brief-type-select'>Brief type</label>
          <div className='flex flex-nowrap'>
            <div className={`select ${styles.dropdownContainer}`}>
              <select
                id='brief-type-select'
                value={selectedBrief}
                onChange={e => setSelectedBrief(e.target.value)}
                disabled={loading}
              >
                <option value='' disabled>
                  -- Select brief type --
                </option>
                <option value='health-check'>Health check brief</option>
                <option value='fleet-makeup'>Fleet makeup brief</option>
              </select>
            </div>

            <button
              onClick={handleRebuild}
              className={`btn ${styles.rebuildBtn} ${!selectedBrief || loading ? 'disabled' : ''}`}
              disabled={!selectedBrief || loading}
            >
              {loading ? 'Wiping...' : 'Wipe brief data'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
